export default __webpack_public_path__ + "static/media/Juliana Gontijo - in memorian.71cae6e9.png";